import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import Section from '../components/Section';
import { useTenant } from '../contexts/TenantContext';
import styles from './JoinTeam.module.css';
import { Megaphone, Building2, ArrowRight, User } from 'lucide-react';
import ApplyModal from '../components/ApplyModal';
import api from '../api/public';
import { useToast } from '../contexts/ToastContext';
import { ListingCard } from '../components/listing/v2';
import Button from '../components/Button';

const JoinTeam = () => {
    const { clubColors } = useTenant();
    const navigate = useNavigate();

    // Helper to get color with fallback
    const getPrimaryColor = () => clubColors?.primary || 'var(--color-primary)';
    const getSecondaryColor = () => clubColors?.secondary || 'var(--color-secondary)';

    const [showModal, setShowModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    const openModalFor = (role) => {
        setSelectedRole(role);
        setShowModal(true);
    };

    const { showSuccess, showError } = useToast();

    const handleSubmit = async (payload) => {
        try {
            await api.submitJoinClubInterest(payload);
            showSuccess('Application submitted — we will reach out soon');
        } catch (err) {
            showError(err?.message || 'Failed to submit application');
            throw err;
        }
    };

    return (
        <PageLayout maxWidth="1200px">
            <PageHeader
                title="Join Us"
                subtitle="Make an impact in youth soccer development. Choose how you want to contribute."
            />

            <Section>
                <div className={styles.optionsContainer}>
                    <ListingCard
                    title="Apply To be a Player"
                    subtitle="Looking to join as a player or register your child? Browse our programs and click 'Learn More' on the program you're interested in."
                    icon={<User size={48} />}
                    iconVariant="secondary"
                    size="large"
                    align="center"
                    className={styles.optionCard}
                    actions={
                        <Button
                            onClick={() => navigate('/programs')}
                            variant="secondary"
                            className={styles.actionButton}
                        >
                            Take Me to Programs Page <ArrowRight size={16} />
                        </Button>
                    }
                />

                <ListingCard
                    title="Apply to be a Coach"
                    subtitle="Passionate about soccer and mentorship? Join us to help shape the next generation of players. We provide the curriculum and support you need to succeed."
                    icon={<Megaphone size={48} />}
                    iconVariant="primary"
                    size="large"
                    align="center"
                    className={styles.optionCard}
                    actions={
                        <Button
                            onClick={() => openModalFor('coach')}
                            variant="primary"
                            className={styles.actionButton}
                        >
                            Apply Now <ArrowRight size={16} />
                        </Button>
                    }
                />

                <ListingCard
                    title="Start a Chapter"
                    subtitle="Bring our proven soccer development model to your community. We provide the platform, tools, and brand to help you launch a successful club."
                    icon={<Building2 size={48} />}
                    iconVariant="secondary"
                    size="large"
                    align="center"
                    className={styles.optionCard}
                    actions={
                        <Button
                            onClick={() => openModalFor('branch_admin')}
                            variant="secondary"
                            className={styles.actionButton}
                        >
                            Get Started <ArrowRight size={16} />
                        </Button>
                    }
                />

                    <ApplyModal isOpen={showModal} onClose={() => setShowModal(false)} appliedForRole={selectedRole} onSubmit={handleSubmit} />
                </div>
            </Section>
        </PageLayout>
    );
};

export default JoinTeam;
